import { UserExam } from '../types/User';

const NBME_EXAM_CONFIG = {
  '8412aecf-480b-4d6a-ad55-e98b08bc21c8': {
    name: 'USMLE Step 1',
    flashcard: [
      { value: 5000, label: '5,000' },
      { value: 9000, label: '9,000' },
      { value: 15000, label: '15,000' },
    ],
    qbank: [
      { value: 1800, label: '1,800' },
      { value: 2500, label: '2,500' },
      { value: 4500, label: '4,500' },
    ],
    examples: {
      highYield: 'HIV, heart failure, stroke',
      standard: 'Renal tubular acidosis, polymyositis, Blastomycosis',
      comprehensive: "Behçet's disease, enchondroma, strychnine poisoning",
    },
    defaultDateOffsetDays: 180,
    defaultDateTimeString: '6 months',
  },
  '88b6758c-3cdb-49e9-8913-5a3553411634': {
    name: 'USMLE Step 2',
    flashcard: [
      { value: 5000, label: '5,000' },
      { value: 9000, label: '9,000' },
      { value: 15000, label: '15,000' },
    ],
    qbank: [
      { value: 1800, label: '1,800' },
      { value: 2500, label: '2,500' },
      { value: 4500, label: '4,500' },
    ],
    examples: {
      highYield: 'HIV, heart failure, stroke',
      standard: 'Renal tubular acidosis, polymyositis, Blastomycosis',
      comprehensive: "Behçet's disease, enchondroma, strychnine poisoning",
    },
    defaultDateOffsetDays: 180,
    defaultDateTimeString: '6 months',
  },
  '0eb1b6b1-e1a0-4400-8c68-75d4236df57a': {
    name: 'Neurology Shelf Exam',
    flashcard: [
      { value: 600, label: '600' },
      { value: 1800, label: '1,800' },
      { value: 3000, label: '3,000' },
    ],
    qbank: [
      { value: 120, label: '120' },
      { value: 360, label: '360' },
      { value: 600, label: '600' },
    ],
    examples: {
      highYield: "Stroke, meningitis, Alzheimer's",
      standard: "Bell's palsy, tethered cord, MSA",
      comprehensive: "Bulbar palsy, McArdle's disease, paraganglioma",
    },
    defaultDateOffsetDays: 28,
    defaultDateTimeString: '4 weeks',
  },
  '47beb60a-ff39-4768-bc85-9488b714bc70': {
    name: 'Psychiatry Shelf Exam',
    flashcard: [
      { value: 600, label: '600' },
      { value: 1800, label: '1,800' },
      { value: 3000, label: '3,000' },
    ],
    qbank: [
      { value: 120, label: '120' },
      { value: 360, label: '360' },
      { value: 600, label: '600' },
    ],
    examples: {
      highYield: 'Depression, schizophrenia, ADHD',
      standard: 'Dysthymia, stimulant use disorder, specific phobia',
      comprehensive: 'Gambling disorder, trichotillomania, pyromania',
    },
    defaultDateOffsetDays: 28,
    defaultDateTimeString: '4 weeks',
  },
  '8b790ec9-5452-484e-bd9c-3b73bb003466': {
    name: 'Surgery Shelf Exam',
    flashcard: [
      { value: 800, label: '800' },
      { value: 2400, label: '2,400' },
      { value: 4000, label: '4,000' },
    ],
    qbank: [
      { value: 180, label: '180' },
      { value: 540, label: '540' },
      { value: 900, label: '900' },
    ],
    examples: {
      highYield: 'Appendicitis, hernia, trauma',
      standard: 'Malignant hyperthermia, flail chest, cauda equina syndrome',
      comprehensive: 'Noonan syndrome, Mucormycosis, latex allergy',
    },
    defaultDateOffsetDays: 56,
    defaultDateTimeString: '8 weeks',
  },
  'e3cbf8d9-545b-4ed3-925a-1ade1f013e2a': {
    name: 'Family Medicine Shelf Exam',
    flashcard: [
      { value: 600, label: '600' },
      { value: 1800, label: '1,800' },
      { value: 3000, label: '3,000' },
    ],
    qbank: [
      { value: 120, label: '120' },
      { value: 360, label: '360' },
      { value: 600, label: '600' },
    ],
    examples: {
      highYield: 'Asthma, diabetes, HIV',
      standard: 'Asbestosis, blepharitis, menopause',
      comprehensive: 'Bruxism, Iliotibial band syndrome, proctalgia fugax',
    },
    defaultDateOffsetDays: 28,
    defaultDateTimeString: '4 weeks',
  },
  'f10b1aa0-dd6d-4376-9bbd-3a1f25500a2e': {
    name: 'OBGYN Shelf Exam',
    flashcard: [
      { value: 800, label: '800' },
      { value: 2400, label: '2,400' },
      { value: 4000, label: '4,000' },
    ],
    qbank: [
      { value: 180, label: '180' },
      { value: 540, label: '540' },
      { value: 900, label: '900' },
    ],
    examples: {
      highYield: 'Preeclampsia, PCOS, molar pregnancy',
      standard: "Bartholin's cyst, Mittelschmerz, breast cysts",
      comprehensive: 'Transfusion reactions, pseudocyesis, Phyllodes tumor',
    },
    defaultDateOffsetDays: 42,
    defaultDateTimeString: '6 weeks',
  },
  '7e18060e-5066-4afa-9b40-d83f98dd905e': {
    name: 'Emergency Medicine Shelf Exam',
    flashcard: [
      { value: 600, label: '600' },
      { value: 1800, label: '1,800' },
      { value: 3000, label: '3,000' },
    ],
    qbank: [
      { value: 120, label: '120' },
      { value: 360, label: '360' },
      { value: 600, label: '600' },
    ],
    examples: {
      highYield: 'Pneumothorax, stroke, appendicitis',
      standard: 'Korsakoff Syndrome, retinal detachment, mumps',
      comprehensive: 'Talus fracture, hydrocele, strychnine poisoning',
    },
    defaultDateOffsetDays: 28,
    defaultDateTimeString: '4 weeks',
  },
  '58e0559f-d98f-4747-984d-caa6d2829761': {
    name: 'Internal Medicine Shelf Exam',
    flashcard: [
      { value: 1400, label: '1,400' },
      { value: 4200, label: '4,200' },
      { value: 7000, label: '7,000' },
    ],
    qbank: [
      { value: 400, label: '400' },
      { value: 1200, label: '1,200' },
      { value: 2000, label: '2,000' },
    ],
    examples: {
      highYield: 'HIV, heart failure, stroke',
      standard: 'Renal tubular acidosis, polymyositis, Blastomycosis',
      comprehensive: "Behçet's disease, enchondroma, strychnine poisoning",
    },
    defaultDateOffsetDays: 56,
    defaultDateTimeString: '8 weeks',
  },
  '67250d46-779b-4208-9b4c-e25e8005ba86': {
    name: 'Pediatrics Shelf Exam',
    flashcard: [
      { value: 800, label: '800' },
      { value: 2400, label: '2,400' },
      { value: 4000, label: '4,000' },
    ],
    qbank: [
      { value: 180, label: '180' },
      { value: 540, label: '540' },
      { value: 900, label: '900' },
    ],
    examples: {
      highYield: 'Jaundice, cystic fibrosis, asthma',
      standard: 'Kawasaki disease, febrile seizure, diaphragmatic hernia',
      comprehensive: 'Megaureter, Kallmann syndrome, pityriasis alba',
    },
    defaultDateOffsetDays: 42,
    defaultDateTimeString: '6 weeks',
  },
} as const;

type QuantityIndex = 0 | 1 | 2; // minimum, recommended, maximum

export const isNbmeExamId = (examId?: string | null) => {
  if (!examId) return false;
  return Object.keys(NBME_EXAM_CONFIG).includes(examId);
};

export const isNbmeExam = (exam?: UserExam | null) => {
  if (!exam) return false;
  return exam.type === 'NBME';
};

export const isStepExam = (exam?: UserExam | null) => {
  if (!exam) return false;
  if (exam?.type === 'NBME') {
    return exam.name.includes('Step');
  }
  return false;
};

export const isShelfExam = (exam?: UserExam | null) => {
  if (!exam) return false;
  if (exam?.type === 'NBME') {
    return exam.name.includes('Shelf');
  }
  return false;
};

export const isVerifiedSchoolExam = (exam?: UserExam | null) => {
  if (!exam) return false;
  if (exam?.type === 'CUSTOM' && exam.verified) {
    return true;
  }
  return false;
};

export const isCustomSchoolExam = (exam?: UserExam | null) => {
  if (!exam) return false;
  if (exam?.type === 'CUSTOM' && !exam.verified) {
    return true;
  }
  return false;
};

const getFlashcardQuantity = (
  exam: UserExam | undefined,
  index: QuantityIndex
): number => {
  if (!exam) {
    return 0;
  }
  if (isNbmeExam(exam)) {
    const examId = exam.id as keyof typeof NBME_EXAM_CONFIG;
    return NBME_EXAM_CONFIG[examId]?.flashcard?.[index]?.value || 0;
  }
  return 0;
};

const getQbankQuantity = (
  exam: UserExam | undefined,
  index: QuantityIndex
): number => {
  if (!exam) {
    return 0;
  }
  if (isNbmeExam(exam)) {
    const examId = exam.id as keyof typeof NBME_EXAM_CONFIG;
    return NBME_EXAM_CONFIG[examId]?.qbank?.[index]?.value || 0;
  }
  return 0;
};

// Convenience functions for specific quantities
export const getHighYieldFlashcards = (exam?: UserExam) =>
  getFlashcardQuantity(exam, 0);
export const getStandardFlashcards = (exam?: UserExam) =>
  getFlashcardQuantity(exam, 1);
export const getComprehensiveFlashcards = (exam?: UserExam) =>
  getFlashcardQuantity(exam, 2);

export const getHighYieldQbank = (exam?: UserExam) => getQbankQuantity(exam, 0);
export const getStandardQbank = (exam?: UserExam) => getQbankQuantity(exam, 1);
export const getComprehensiveQbank = (exam?: UserExam) =>
  getQbankQuantity(exam, 2);

export const defaultFlashcards = (exam?: UserExam) =>
  getHighYieldFlashcards(exam);
export const defaultVignettes = (exam?: UserExam) => getHighYieldQbank(exam);

export const getExamples = (exam?: UserExam) => {
  if (isNbmeExam(exam) && exam?.id) {
    return NBME_EXAM_CONFIG[exam.id as keyof typeof NBME_EXAM_CONFIG]?.examples;
  }
  return undefined;
};
